import { AppSettingService } from './app-setting.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppValidationService {

  constructor(public appSettingService: AppSettingService) { }

 public  checkRoleExistence(roleLabel: string):boolean {
  let resultValue;
  if (this.appSettingService.roleGlobelList !== null || this.appSettingService.roleGlobelList !== undefined) {
    if (this.appSettingService.roleGlobelList.some(r => r.roleType === roleLabel)) {
      resultValue = true;
    } else {
      resultValue = false;
    }
  } else {
    resultValue = false;
  }
  return resultValue;
  }
}
